import React, { FC } from 'react';

const AlignCenter: FC<any> = ({ stroke = '#000' }: any) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3 8H21M3 12H21M3 16H21M17 20H7M3 4H21"
      stroke={stroke}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default AlignCenter;
